module.exports = __webpack_public_path__ + "static/media/logo_unilos.dce39656.svg";